import React from "react";
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import NavBar from '../components/navbar';
import TopAiDataEngineers from '../components/TopAiDataEngineers';

const useStyles = makeStyles((theme) => ({
  root: {
    marginLeft: '15px',
    paddingRight: '30px'
  },
  title: {
    marginTop: '50px', 
    marginLeft: '10px'
  },
  grey: {
    color: '#414041'
  },
  blue: {
    color: '#153BAB'
  }
}))


// const talents = [
//   {
//     title: 'Senior AI Developer',
//     description: "I am a French national holding MSc’s in both Structural Engineering and Marketing. A former senior manager in Marketing and Sales, I transitioned into Data Science and Machine Learning, motivated by my interest in data analytics, predictive models and personal development. I built my initial experience through projects and consultancy work, then entered a PhD program in Deep Learning.",
//     skills: ['Deep Learning', 'Analytics', 'Programming', 'Project Management'],
//     experience: [
//       {
//         title: 'job sample',
//         from: '2010',
//         to: '2015'
//       },
//       {
//         title: 'job sample',
//         from: '2015',
//         to: '2019'
//       },
//       {
//         title: 'job sample',
//         from: '2019',
//         to: '2020'
//       },
//     ]
//   },
//   {
//     title: 'Lead Data Scientist',
//     description: 'Highly ambitious Data scientist with a background in research, computer vision and bioinformatics. Expertise in building and tuning deep learning models, dataset acquisition and video analysis',
//     skills: ['Python', 'Tensoflow', 'Mathlab', 'opencv', 'AWS', 'SQL'],
//     experience: []
//   }
// ]


const ServiceResults = (props) => {
  const classes = useStyles();
  const [talents, setTalents] = React.useState([])
  const [update, setUpdate] = React.useState(props.location.searchParm != null)
  let searchParm 
  if(props.location.searchParm){
    searchParm = props.location.searchParm
  } else {
    props.history.push({
      pathname: '/service'
    })
  }

  React.useEffect(() => {
    if(update){
      fetch(process.env.REACT_APP_LOCAL_IP + '/search', {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(searchParm)
      }).then(res => res.json())
      .then(res => {
        const arr = res.ids
        arr.forEach((item) => {
          const  skills = [];
          const experience = []
          for (const skill in item.skills) {
            skills.push(item.skills[skill].skill)
          }
          for (const exp in item.workExp) {
            const work = {
              title: item.workExp[exp].Title,
              from: item.workExp[exp].startyear,
              to: (item.workExp[exp].endyear)? item.workExp[exp].endyear : ""
            }
            experience.push(work)
          }
          const talent = {
            title: item.role,
            description: item.bio,
            skills: [...skills],
            experience: [...experience]
          }          
          const newTalents = [...talents];
          newTalents.push(talent)
          setTalents(newTalents)
          setUpdate(false)
        });
      })
    }
  })
  

  return (
    <div>
      <NavBar type='main' />
      <Grid 
      container 
      direction="row"
      justify="flex-start"
      alignItems="center"
      spacing={5}
      className={classes.root}
      >
        <Grid item xs={10} className={classes.title}>
          <h1>
            <strong>
              <span className={classes.blue}>TOP </span>
              <span className={classes.grey}> AI &amp; Data Engineers</span>
            </strong>
          </h1>
        </Grid>
        <Grid item xs={10}>
          <TopAiDataEngineers talents={talents}/>
        </Grid>
      </Grid>
    </div>
  );
}


export default ServiceResults;
